import * as React from "react";
import SearchUsers from "../../features/SearchUsers";
import BaseLayout from "../../components/BaseLayout";

function SearchUsersPage() {
  return (
    <BaseLayout paddingTop>
      <SearchUsers searchType={"user"} />
    </BaseLayout>
  );
}

export default SearchUsersPage;
